import { signal } from "@preact/signals-react"

export const agentManifestLoadedSignal = signal(false)
export const agentManifestErrorSignal = signal(null)
export const agentManifestSignal = signal([])